import { Message, Messages } from "@/models/Message"
import firebase from 'firebase/app'

class MessageRepository {
  constructor(client) {
    this.collection = client.collection("messages")
    this.snapShotOptions = { serverTimestamps : 'estimate' }
    this.subscribe = null
  }

  async sendMessage(
    senderId,
    receiverId,
    content
  ) {
    const timestamp = firebase.firestore.FieldValue.serverTimestamp()
    const senderDocRef = await this.collection.doc(senderId).collection(receiverId).doc()
    const message = new Message(
      senderDocRef.id,
      senderId,
      receiverId,
      content,
      timestamp,
      timestamp
    )
    const object = message.toObject()
    senderDocRef.set(object.data)
    const result = await senderDocRef.get()
    const receiverDocRef = await this.collection.doc(receiverId).collection(senderId).doc(result.id)
    receiverDocRef.set(object.data)
    return createFromFirestoreData(result.id, result.data(this.snapShotOptions))
  }

  async list(selfId, partnerId) {
    const snapShot = await this.collection.doc(selfId).collection(partnerId).orderBy("createdAt").get()
    let arr = []
    snapShot.forEach(doc => {
      arr.push(createFromFirestoreData(doc.id, doc.data(this.snapShotOptions)))
    })
    return arr
  }

  async startWatching(selfId, partnerId) {
    const query = this.collection.doc(selfId).collection(partnerId).orderBy("createdAt")
    let arr = []
    this.subscribe = query.onSnapshot((snapShot) => {
      snapShot.forEach(doc => {
        arr.push(createFromFirestoreData(doc.id, doc.data(this.snapShotOptions)))
      })
    })
    return createMessages(arr)
  }

  async stopWatching() {
    this.subscribe()
  }
}

const createFromFirestoreData = (id, data) => {
  return new Message(
    id,
    data.senderId,
    data.receiverId,
    data.content,
    data.createdAt.toDate(),
    data.updatedAt.toDate()
  )
}

const createMessages = (arr) => {
  if(!(arr instanceof Array)) {
    throw new TypeError(`'arr' must be an instance of [object Array]. Actual: ${typeof arr}`)
  }
  return new Messages(arr)
}

export { MessageRepository }